/* eslint-disable */
import React from "react";
import {
  Button,
  NotificationHub,
  FormRadioCheckboxButton,
  DataArray,
  Box,
  Link
} from "@nef/core";
import styled from "styled-components";

const StyledReviewAndSubmit = styled(Box)`
&.review-and-submit{
  margin-top: 100px;
  .review-and-submit-container{
    width: 700px;
  }
  div{
    margin: auto;
  }
  .terms{
    width: 30px;
    margin: 0;
  }
  span{
    display: flex;
  }
  .box{
    display: flex;
  }
  .action-buttons{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
  }
}
`;

export default StyledReviewAndSubmit;
